import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RolePickerComponent } from 'src/app/shared/components/role-picker/role-picker.component';
import { AvailablePermission } from 'src/app/core/models/dto/availablePermission';

@Component({
  selector: 'app-permission-group-edit-modal',
  templateUrl: './permission-group-edit-modal.component.html',
  standalone: false,
})
export class PermissionGroupEditModalComponent implements OnInit {
  @ViewChild(RolePickerComponent) picker?: RolePickerComponent;

  id?: string;
  name: string = '';
  readOnly: boolean = false;
  availablePermissions: AvailablePermission[] = [];
  selectedPermissions: AvailablePermission[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    const group = this.config.data?.group;
    this.id = group?.id;
    this.name = group?.name || '';
    this.readOnly = !!this.config.data?.readOnly;
    const allPermissions: AvailablePermission[] =
      this.config.data?.availablePermissions || [];

    // Enriquece as permissões já selecionadas (apenas chaves) com o rótulo (URL),
    // usando o mapa de permissões disponíveis; mantém a chave para salvar.
    const labelByName = new Map<string, string>(
      allPermissions.map((p) => [p.name, p.label]),
    );
    const selectedNames: string[] = group?.permissionNames || [];
    this.selectedPermissions = selectedNames.map((name) => ({
      name,
      label: labelByName.get(name) || name,
    }));

    // "Available" mostra apenas o que ainda não está selecionado.
    // Para grupos com acesso total (ex.: AdminGlobal), a coluna fica vazia.
    const selectedNameSet = new Set<string>(selectedNames);
    this.availablePermissions = allPermissions.filter(
      (p) => !selectedNameSet.has(p.name),
    );
  }

  save(): void {
    if (this.readOnly) {
      this.close();
      return;
    }

    const selected = (this.picker?.getSelectedRaw() || []) as string[];
    const normalizedName = (this.name || '').trim();

    this.ref.close({
      id: this.id,
      name: normalizedName,
      permissionNames: selected,
    });
  }

  close(): void {
    this.ref.close();
  }
}
